import { createReducer } from '../../utilities';

import { scope } from '../../../actions/app/tools/topflop';
import {
  GET_TOP_PLAYERS, GET_TOP_PLAYERS_SUCCESS, GET_TOP_PLAYERS_ERROR,
  GET_FLOP_PLAYERS, GET_FLOP_PLAYERS_SUCCESS, GET_FLOP_PLAYERS_ERROR
} from '../../../actions/entities/player.js';

const initialState = {
    ids: null,
    info: {
        isFetching: false,
        lastAction: null,
        lastPayload: {},
        needRefresh: true,
        updatedAt: null,
        success: false,
        error: false
    }
};

function request(state, action) {
    return {
        ...state,
        info: {
            isFetching: true,
            lastAction: action.type,
            lastPayload: action.payload,
            needRefresh: false,
            updatedAt: null,
            success: false,
            error: false
        }
    };
}

function success(state, action) {
    const { ids, payload, receivedAt, success } = action;
    return {
        ...state,
        ids: ids || state.ids,
        info: {
            ...state.info,
            isFetching: false,
            lastPayload: payload,
            needRefresh: false,
            updatedAt: receivedAt,
            success,
            error: false
        }
    };
}

function fail(state, action) {
    const { error, payload } = action;
    return {
        ...state,
        info: {
            ...state.info,
            isFetching: false,
            lastPayload: payload,
            needRefresh: false,
            success: false,
            error
        }
    };
}

export default createReducer(initialState, {
    [GET_TOP_PLAYERS]: request, [GET_FLOP_PLAYERS]: request,
    [GET_TOP_PLAYERS_SUCCESS]: success, [GET_FLOP_PLAYERS_SUCCESS]: success,
    [GET_TOP_PLAYERS_ERROR]: fail, [GET_FLOP_PLAYERS_ERROR]: fail
}, scope);



// WEBPACK FOOTER //
// ./src/reducers/app/tools/topflop.js